<template>
	<div>
		<GenericSelector 
			:value="value"
			@input="val => $emit('input', val)"
			:options="options" 
			:showOptions="showOptions"
			:canEdit="showOptions"
			:loading="loading || loadingOptions"
			displayKey="Name"
		>
			<template v-slot:selectedTop>
				<div class="font-weight-bold list-group-item">{{ $t('name') }}</div>
			</template>
			
			<template v-slot:unselectedHeader>
				<div class="clearfix my-2">
					<SearchBar v-if="showOptions" v-model="search" :debounce="false" class="float-left" />

					<button 
						type="button" 
						@click="showOptions = !showOptions"
						class="btn float-right" 
						:class="showOptions ? 'btn-secondary' : 'btn-primary'"
					>
						<b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
					</button>
				</div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import SearchBar from "src/components/Table/SearchBar"
import GenericSelector from "../Inputs/GenericSelector.vue";

export default {
	components: {
		SearchBar,
		GenericSelector,
	},
	props: {
		value: Array,
		loading: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			loadingOptions: true,
			tests: [],
			showOptions: false,
			search: '',
		};
	},
	mounted() {
        this.fetchTests().then(() => this.loadingOptions = false);
    },
	methods: {
        fetchTests() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/tests/listall`, {
                method: 'POST'
            })
            .then((res) => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching tests')
				
				this.tests = res.results
			})
			.catch(error => {
				console.error(error)
				this.$log.error.call(this, error);
			});
        },
	},
	computed: {
		options() {
			return this.tests.filter(test => !this.search || test.Name.toLowerCase().includes(this.search.toLowerCase()))
		}
	}
};
</script>
